import type { GamificationMeResponseDto } from '@schwrz/shared';
import { defineStore } from 'pinia';
import { ref } from 'vue';

import { api } from '../shared/api/client';

export const useGamificationStore = defineStore('gamification', () => {
  const me = ref<GamificationMeResponseDto | null>(null);
  const loading = ref(false);

  async function load(): Promise<void> {
    loading.value = true;
    try {
      me.value = await api<GamificationMeResponseDto>('/api/gamification/me');
    } finally {
      loading.value = false;
    }
  }

  /** Re-fetch after any action that may shift points (task done, request decided, etc). */
  async function refresh(): Promise<void> {
    me.value = await api<GamificationMeResponseDto>('/api/gamification/me');
  }

  return { me, loading, load, refresh };
});
